import axios from 'axiosConfig';

export const getAllPaymentFrequency = () => axios.post("/api/loanmaster/paymentfrequency", {});

export const getAllInterestType = () => axios.post("/api/loanmaster/amortizationtype", {});

export const getAllInterestPerYear = () => axios.post("/api/loanmaster/interestperyear", {});

